<template>
  <div>
    <div class="mb-12 mx-auto">
      <slot></slot>
    </div>
    <div class="w-full mx-auto flex lg:flex-row flex-col justify-center items-center lg:justify-between">
      <!-- Text home   -->
      <div
          :class="['flex flex-col justify-center items-center text-center lg:text-start lg:justify-start lg:items-start w-full lg:w-1/2',
        order1lg, order1sm]">
        <slot name="slot1"></slot>
      </div>

      <!--Image home-->
      <div :class="['mb-4 w-full lg:w-1/2', order2lg, order2sm]">
        <slot name="slot2"></slot>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "ContentComponent",
  props: {
    order1lg: {
      type: String,
      default: "order-2",
    },
    order2lg: {
      type: String,
      default: "order-1",
    },
    order1sm: {
      type: String,
      default: "order-1",
    },
    order2sm: {
      type: String,
      default: "order-2",
    },
  }
}
</script>